"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m2.913 10.034-1.228 3.18h.54v1H.1v-1h.513L4.95 1.979a.5.5 0 0 1 .466-.32h.003a.5.5 0 0 1 .466.324l4.21 11.23h.693v1H8.663v-1h.364l-1.192-3.18H2.913Zm.386-1H7.46l-2.05-5.47-2.111 5.47Zm11.19 4.137-.667-1.777h-3.19l-.208.521-.53-.993.014-.033 1.957-5.074c.075-.193.26-.352.47-.32a.501.501 0 0 1 .465.325l2.756 7.35h.344v1h-1.412v-.999Zm-2.164-5.77 1.122 2.993H11.17l1.155-2.992Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m4.137 13.885-2.016 5.224h1.107v1.125H0v-1.125h.915L7.55 1.917a.573.573 0 0 1 .527-.36.564.564 0 0 1 .525.365l6.443 17.187h1.19v1.125h-3.228v-1.125h.837l-1.958-5.224H4.137Zm.434-1.125h6.893L8.067 3.702 4.571 12.76Zm17.569 6.283-1.16-3.093h-4.906l-.393.989-.646-1.396.148-.388.014-.006 2.858-7.405c.084-.219.278-.344.527-.36a.56.56 0 0 1 .524.365l4.234 11.294H24v1.125h-2.144v-1.125h.284Zm-3.568-9.515 1.986 5.297h-4.03l2.044-5.297Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m5.516 18.513-2.688 6.965h1.476v1.5H0v-1.5h1.22l8.847-22.923c.112-.29.38-.464.703-.48a.752.752 0 0 1 .699.487l8.592 22.916h1.585v1.5h-4.304v-1.5h1.117l-2.612-6.965H5.516Zm.579-1.5h9.19L10.756 4.935 6.095 17.013Zm23.424 8.377-1.545-4.123h-6.542l-.524 1.317-.86-1.86.196-.518.018-.007 3.812-9.874c.112-.291.37-.458.703-.48a.748.748 0 0 1 .698.487L31.12 25.39H32v1.5h-2.859v-1.5h.378Zm-4.756-12.686 2.648 7.063h-5.375l2.727-7.063Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.063 27.72 3.936 38.415h2.439v1.875H0v-1.875h1.927L15.073 4.35c.14-.362.488-.6.875-.6h.004c.39.002.737.244.874.608l12.769 34.056h2.468v1.875h-6.375v-1.875h1.904L23.594 27.75H8.063v-.03Zm.713-1.845H22.89l-6.955-18.55-7.16 18.55Zm35.199 12.409-2.42-6.455h-9.919l-.769 1.932-.963-2.561.045-.12-.003-.002 5.874-15.22c.14-.362.487-.6.874-.6h.005a.94.94 0 0 1 .874.609l8.405 22.417h1.421v1.875h-4.234v-1.875h.81ZM32.587 29.44l.167-.419-.006.004 3.934-10.193 4.17 11.122h-8.463l.198-.514Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.751 36.961 5.248 51.219H8.5v2.5H0v-2.5h2.569L20.098 5.8c.186-.481.65-.8 1.166-.8h.006c.519.004.982.326 1.165.812L39.459 51.22h3.292v2.5h-8.5v-2.5h2.538L31.458 37H10.751v-.039Zm.95-2.46h18.82L21.247 9.765 11.7 34.5Zm46.932 16.544-3.227-8.606H42.183l-1.026 2.576-1.285-3.415.062-.16-.005-.003 7.832-20.294c.186-.482.65-.8 1.166-.8h.006c.519.003.982.326 1.165.812l11.206 29.89H63.2v2.5h-5.646v-2.5h1.08ZM43.448 39.26l.224-.565-.008.005 5.245-13.59 5.56 14.83H43.185l.263-.68Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconFontSize = function IconFontSize(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Font Size' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "FontSize"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconFontSize.sizes = [16, 24, 32, 48, 64];
IconFontSize.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconFontSize;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/FontSize.js
// module id = 1761
// module chunks = 0